<template>
    <div class="content-wrap">
        <resultFilter @searchForm="getSearchForm"></resultFilter>
        <div class="card-wrap">
            <div class="card-title">
                <div class="card-title-left">渠道贡献</div>
                <div class="card-title-right">
                    <div :class="sChannelItem === 'obtain' ? 'card-title-right-act' : 'card-title-right-item'" @click="changeTab(0)">
                        获客
                    </div>
                    <div :class="sChannelItem === 'sign' ? 'card-title-right-act' : 'card-title-middle-item'" @click="changeTab(1)">
                        金额
                    </div>
                    <div :class="sChannelItem === 'product' ? 'card-title-right-act' : 'card-title-right-item'" @click="changeTab(2)">
                        项目
                    </div>

                </div>
            </div>
            <div id="contribute-pie"></div>
            <div id="contribute-bar"></div>
            <div class="radio-wrap" style="border: none">
                <div class="radio-item">
                    <img :src="sRatio === 'same' ? selectImg : noSelectImg" alt="" @click="clickRadio('same')">
                    <div>同比</div>
                </div>
                <div class="radio-item">
                    <img :src="sRatio === 'ring' ? selectImg : noSelectImg" alt="" @click="clickRadio('ring')">
                    <div>环比</div>
                </div>
            </div>
        </div>
        <div class="card-wrap">
            <div class="card-title">
                <div class="card-title-left">渠道榜单</div>
            </div>
            <div class="contribute-table">
                <el-table :data="arrChannelRank" :header-row-style="{ color: '#318544', border: 'none' }" :cell-style="cellStyle">
                    <el-table-column align="center" prop="date" label="排名" type="index" :index="indexMethod" width="60"></el-table-column>
                    <el-table-column align="center" prop="second" label="二级渠道" width="90">
                    </el-table-column>
                    <el-table-column align="center" prop="first" label="一级渠道" width="70">
                    </el-table-column>
                    <el-table-column align="center" prop="money" label="业绩">
                        <template slot-scope="scope">
                            <div class="flc yj">
                                <div class="amount">{{scope.row.money}}万</div>
                                <div class="flc">
                                    <img :src="scope.row.type === 'up' ? upIcon : downIcon" style="width: 14px; height: 14px" alt="">
                                    <div :style="{ color: scope.row.type === 'up' ? '#318544' : '#EB6F56', lineHeight: '20px' }">{{scope.row.percent}}</div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import resultFilter from "@/components/hvac/performance/project/resultfilter.vue";
import oChannelJs from "@/js/hvac/performance/result.js"

export default {
    name: "channel",
    components: {
        resultFilter,
    },
    created() {
        this.getChannelContribution()
        $init(() => {

        })
    },
    data() {
        return {
            //签到获客判断
            sChannelItem: "product",
            up: true,
            upIcon: require("@/assets/images/result/up_icon.png"),
            downIcon: require("@/assets/images/result/down_icon.png"),
            //搜索表单
            oSearchForm: {
                //...
                agent: "",
                area: "",
                channel: "",
                city: "",
                worker: "",
                start: "",
                end: ""
            },
            //渠道贡献
            arrChannelPie: [],
            oChannelPie: null,
            nContributeNum: 0,
            arrContributeBarX: [],
            arrContributeBarY: [],
            oChannelBar: null,
            //渠道榜单
            arrChannelRank: [],
            sRatio: "same",
            selectImg: require('@/assets/images/result/select.png'),
            noSelectImg: require('@/assets/images/result/noSelect.png'),
        };
    },
    mounted() {
        setTimeout(() => {
            this.createContributeBar();
            this.createContributePie();
        }, 500);
    },
    methods: {
        indexMethod(index) {
            return 'NO.' + (index + 1)
        },
        cellStyle(row) {
            if (row.columnIndex === 1) {
                return "color: #222222; fontWeight: 500";
            }
        },
        changeTab(index) {
            switch (index) {
                case 0:
                    if (this.sChannelItem != "obtain") {
                        this.sChannelItem = "obtain"
                        this.getChannelContribution()
                    }
                    break
                case 1:
                    if (this.sChannelItem != "sign") {
                        this.sChannelItem = "sign"
                        this.getChannelContribution()
                    }
                    break
                case 2:
                    if (this.sChannelItem != "product") {
                        this.sChannelItem = "product"
                        this.getChannelContribution()
                    }
                    break
            }
        },
        createContributeBar() {
            let sUnit = this.handlerUnit()
            if (this.oChannelBar != null &&
                this.oChannelBar != "" &&
                this.oChannelBar != undefined) {
                this.oChannelBar.dispose();
            }
            this.oChannelBar = this.$echarts.init(
                document.getElementById("contribute-bar")
            );

            let arrSeries = []
            this.arrContributeBarY.forEach(item => {
                arrSeries.push({
                    name: item.name,
                    data: item.data,
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'right',
                        textStyle: {
                            fontSize: 14,
                            color: '#A2A2A2'
                        },
                        formatter: '{c}' + sUnit
                    },
                })
            })

            const OPTIONS = {
                color: ["rgba(91, 143, 249, 0.85)", "rgba(90, 216, 166, 0.85)"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                    formatter(params) {
                        //悬浮提示增加单位
                        let res = ""
                        for (let i = 0; i < params.length; i++) {
                            let series = params[i];
                            if (i == 0) {
                                res = series.axisValue + "<br/>" + series.marker + series.seriesName + "：" + series.data + sUnit + "<br/>";
                            } else {
                                res = res + series.marker + series.seriesName + "：" + series.data + sUnit + "<br/>";
                            }
                        }
                        return res
                    }
                },
                grid: {
                    right: "18%",
                    left: "1%",
                    bottom: "2%",
                    top: "15%",
                    containLabel: true,
                },
                legend: {

                },
                xAxis: {
                    type: "value",
                    show: false,
                    splitLine: {
                        show: true,
                    },

                },
                yAxis: {
                    type: "category",
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: "rgba(0, 0, 0, 0.15)",
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            fontSize: 14,
                            color: "rgba(0, 0, 0, 0.45)",
                        },
                        formatter: function (params) {
                            let tempArr = params.split("/");
                            if (tempArr.length > 1) {
                                return tempArr[0] + "\n" + tempArr[1];
                            }

                            return params;
                        },
                    },
                    data: this.arrContributeBarX
                },
                series: arrSeries
            };
            this.oChannelBar.setOption(OPTIONS);
        },
        createContributePie() {
            if (this.oChannelPie != null &&
                this.oChannelPie != "" &&
                this.oChannelPie != undefined) {
                this.oChannelPie.dispose();
            }
            this.oChannelPie = this.$echarts.init(
                document.getElementById("contribute-pie")
            );
            let sTitle = ""// this.sChannelItem == "sign" ? "上线用户" : "订单金额"
            if (this.sChannelItem === "obtain") {
                sTitle = "上线用户"
            } else if (this.sChannelItem === "sign") {
                sTitle = "订单金额"
            } else if (this.sChannelItem === "product") {
                sTitle = "项目个数"
            } else {
                sTitle = ""
            }
            let sUnit = this.handlerUnit()
            const OPTIONS = {
                tooltip: {
                    trigger: "item",
                },
                color: [
                    "rgba(0, 0, 0, 0.85)",
                    "rgba(91, 143, 249, 0.85)",
                    "rgba(90, 216, 166, 0.85)",
                    "rgba(93, 112, 146, 0.85)",
                    "rgba(246, 189, 22, 0.85)",
                    "rgba(232, 104, 74, 0.85)",
                ],
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    top: "3%",
                    containLabel: true,
                },
                series: [
                    {
                        type: "pie",
                        radius: ["30%", "60%"],
                        center: ["50%", "50%"],
                        avoidLabelOverlap: true,

                        data: [{}],
                        label: {
                            normal: {
                                show: true,
                                position: "center",
                                color: "#4c4a4a",
                                formatter:
                                    "{count|" +
                                    this.nContributeNum + sUnit +
                                    "}" +
                                    "\n\r" +
                                    "{title|" + sTitle + "}",
                                rich: {
                                    count: {
                                        fontSize: 28,
                                        fontFamily: "微软雅黑",
                                        color: "#000000",
                                    },
                                    title: {
                                        fontFamily: "微软雅黑",
                                        fontSize: 12,
                                        color: "#858585",
                                        lineHeight: 30,
                                    },
                                },
                            },
                            emphasis: {
                                //中间文字显示
                                show: true,
                            },
                        },
                    },
                    {
                        type: "pie",
                        radius: ["30%", "60%"],
                        center: ["50%", "50%"],
                        avoidLabelOverlap: true,
                        data: this.arrChannelPie,
                        itemStyle: {
                            normal: {
                                label: {
                                    // alignTo: 'edge',
                                    // minMargin: 5,
                                    // edgeDistance: 10,
                                    // lineHeight: 15,
                                    show: true,
                                    position: "outside",
                                    textStyle: {
                                        color: "#858585",
                                        fontWeight: 200,
                                        fontSize: 14,
                                    },
                                    formatter: function (p) {
                                        return p.name + "\n" + p.percent + "%";
                                    },
                                },
                                labelLine: {
                                    //指示线状态
                                    show: true,
                                    length: 10,
                                    length2: 12,
                                },
                            },
                        },
                    },
                ],
            };
            this.oChannelPie.setOption(OPTIONS);
        },
        getSearchForm(val) {
            this.oSearchForm = val;
            this.getChannelContribution();
            this.getChannelRank();
        },
        getChannelContribution() {
            let data = {
                agent: this.oSearchForm.agent,
                area: this.oSearchForm.area,
                channel: this.oSearchForm.channel,
                city: this.oSearchForm.city,
                worker: this.oSearchForm.worker,
                start: this.oSearchForm.start,//"2021-05-01"//,//"2021-5-23",//
                end: this.oSearchForm.end,//"2021-12-23",
                item: this.sChannelItem,
                ratio: this.sRatio
            }
            oChannelJs.getChannelContribution(data).then(res => {
                let results = res.data.data.result;
                this.arrChannelPie = results.pie;
                this.nContributeNum = results.num
                this.createContributePie();
                //条形图
                this.arrContributeBarX = results.histogram.item.reverse();
                this.arrContributeBarY = results.histogram.data;
                this.arrContributeBarY.forEach(item => {
                    item.data = item.data.reverse();
                })
                this.createContributeBar();
            });
        },
        getChannelRank() {
            let data = {
                agent: this.oSearchForm.agent,
                area: this.oSearchForm.area,
                channel: this.oSearchForm.channel,
                city: this.oSearchForm.city,
                worker: this.oSearchForm.worker,
                start: this.oSearchForm.start, //"2021-05-01",//
                end: this.oSearchForm.end,//, "2021-12-23",
            }
            oChannelJs.getChannelRank(data).then(res => {
                let results = res.data.data.result;
                this.arrChannelRank = results;
                //console.log(this.arrChannelRank)
            })
        },
        //同比环比 点击事件
        clickRadio(ratio) {
            if (this.sRatio != ratio) {
                this.sRatio = ratio;
                this.getChannelContribution();
            }
        },
        handlerUnit() {
            if (this.sChannelItem === "obtain") {
                // return {
                //     title:"上线用户",
                //     unit:"人"
                // }
                return "人"
            } else if (this.sChannelItem === "sign") {
                // return {
                //     title:"订单金额",
                //     unit:"万"
                // }
                return "万"
            } else if (this.sChannelItem === "product") {
                // return {
                //     title:"项目个数",
                //     unit:"个"
                // }
                return "个"
            } else {
                return ""
            }
        }

    },
};
</script>

<style lang="scss" scoped>
.content-wrap {
    background: #f0f4f1;

    .card-wrap {
        width: 93.6%;
        margin: 24px auto 0;
        padding: 28px 24px 32px;
        border-radius: 12px;
        background: #fff;

        &:last-child {
            margin-bottom: 48px;
        }

        .card-title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .card-title-left {
                font-size: 28px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #222222;
                line-height: 40px;
            }

            .card-title-right {
                display: flex;
                border-radius: 12px;
                overflow: hidden;
                border: 2px solid #6c9276;

                .card-title-right-act {
                    width: 100px;
                    height: 56px;
                    background: #318544;
                    /*border-radius: 12px 0px 0px 12px;*/

                    font-size: 24px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    text-align: center;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 56px;
                }

                .card-title-right-item {
                    width: 100px;
                    height: 56px;
                    font-size: 24px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    text-align: center;
                    color: #318544;
                    line-height: 56px;
                }
                .card-title-middle-item {
                    width: 100px;
                    height: 56px;
                    font-size: 24px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    text-align: center;
                    color: #318544;
                    line-height: 56px;
                    border-left: 1px solid #318544;
                    border-right: 1px solid #318544;
                }
            }
        }
        .radio-wrap {
            display: flex;
            padding: 30px 0;
            border-bottom: 2px dashed #f1f1f1;
            justify-content: space-around;
            align-items: center;

            .radio-item {
                display: flex;
                align-items: center;
                img {
                    width: 36px;
                    height: 36px;
                    margin-right: 8px;
                }

                div {
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #444444;
                    line-height: 40px;
                }
            }
        }
        .contribute-table {
            width: 100%;
            margin-top: 20px;

            .yj {
                display: flex;
                justify-content: space-evenly;

                .amount {
                    font-size: 24px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #318544;
                    line-height: 32px;
                }
            }
        }

        #contribute-pie {
            width: 100%;
            height: 680px;
        }

        #contribute-bar {
            width: 100%;
            height: 750px;
        }
    }
}

.flc {
    display: flex;
    align-items: center;
}
</style>